interface IValidatorStrategies {
  [key: string]: (value: string, errorMsg: string) => string | undefined;
}
//校验数字且最多两位小数的正则
let twoDecimalNumberReg = /^\d+(\.\d{1,2})?$/;
/**
 * 验证策略
 */
const validatorStrategies: IValidatorStrategies = {
  // 必填
  required(value: string, errorMsg: string): string | undefined {
    return value === '' ? errorMsg || '表单未填写不完整' : undefined;
  },
  // 名称正则
  name(value: string, errorMsg: string): string | undefined {
    return value.length > 20 ? errorMsg || '名称最长20字符' : undefined;
  },
  // 描述正则
  desc(value: string, errorMsg: string): string | undefined {
    return value.length > 500 ? errorMsg || '描述最长500字符' : undefined;
  },
  //价格正则
  price(value: string, errorMsg: string): string | undefined {
    if (!twoDecimalNumberReg.test(value)){
      return errorMsg || '价格必须为正数且最多两位小数';
    }
    if (Number(value) === 0){
      return errorMsg || '价格不能为0';
    }
    return undefined;
  }
};

/**
 * 表单验证
 * @param rule 规则
 * @param value 输入框的值
 */
export default function validator(rule: { required: boolean, requiredMsg?: string, type?: string, typeMsg?: string}, value: string | number | null): string | undefined {
  if (rule.required && !value) {
    return validatorStrategies.required('', rule.requiredMsg || '');
  }
  if (rule.type && Object.keys(validatorStrategies).indexOf(rule.type) >= 0) {
    return validatorStrategies[rule.type](value ? value + '' : '', rule.typeMsg || '');
  } else {
    return undefined;
  }
}
